


export enum EnumSystemOptionsZ {
    SystemOptionID = "SystemOptionID",
    PaymentSuccessURL = "PaymentSuccessURL",
    PaymentBackURL = "PaymentBackURL"


}
export enum EnumEntityTypes {
    Invoice = "Invoice",
    Receipt = "Receipt",
    Order = "Order",
    PaymentRequest = "PaymentRequest",
    ContactPerson = "ContactPerson",
    CustomerAddress = "CustomerAddress"


}
export enum EnumInvoicePaymentTypes {
    NotPaid = "NotPaid",
    PaidPartially = "PaidPartially",
    Paid = "Paid",
    OutstandingCredit = "OutstandingCredit",
    Open = "Open",
    Closed = "Closed"


}
export enum EnumLoginRequestTypes {
    Payment = "Payment",
    AgingReport = "AgingReport",
    PersonDetails = "PersonDetails"


}
export enum EnumCustomerAddressTypes {
    Ship = "Ship",
    Bill = "Bill"


}
export enum EnumPaymentRequestTypes {
    PaymentByExistingCard = "PaymentByExistingCard",
    PaymentByNewCard = "PaymentByNewCard",
    ChangeCard = "ChangeCard",
    Paypal = "Paypal",
    Bit = "Bit"


}
export enum EnumPaymentRequestStatuses {
    Created = "Created",
    Sent = "Sent",
    Confirmed = "Confirmed",
    Executed = "Executed",
    Error = "Error",
    Cancelled = "Cancelled",
    Resolved = "Resolved",
    PendingConfirm = "PendingConfirm"


}
export enum EnumAutoCreationDocumentTypes {
    None = "None",
    Invoice = "Invoice",
    Order = "Order"


}
export enum EnumFileTypes {
    Pdf = "Pdf",
    Word = "Word",
    Excel = "Excel",
    Text = "Text",
    Archive = "Archive",
    Html = "Html",
    Image = "Image",
    Xml = "Xml",
    Video = "Video",
    Email = "Email",
    Unknown = "Unknown"


}
export enum EnumReportTabs {
    Ledger = "Ledger",
    Invoice = "Invoice",
    AgingReport = "AgingReport",
    Delivery = "Delivery"


}
export enum EnumUserTypes {
    User = "User",
    Admin = "Admin"


}
export enum EnumPaymentRequestSteps {
    SendToPaymentService = "SendToPaymentService",
    ConfirmInPaymentService = "ConfirmInPaymentService",
    ExecuteInPaymentService = "ExecuteInPaymentService",
    SaveInvoice = "SaveInvoice",
    SaveOrder = "SaveOrder",
    SaveReceipt = "SaveReceipt",
    UpdateTransactionRefDataInPaymentService = "UpdateTransactionRefDataInPaymentService",
    SaveCreditCard = "SaveCreditCard",
    SendInvoice = "SendInvoice",
    SendOrder = "SendOrder",
    SendReceipt = "SendReceipt",
    Rollback = "Rollback",
    AdminNotificationSent = "AdminNotificationSent",
    TransferedToPaymentService ="TransferedToPaymentService"


}
export enum EnumSystemTypes {
    SBO = "SBO",
    Zulu = "Zulu",
    Landlord = "Landlord"


}
export enum EnumCredentialTypes {
    Admin = "Admin",
    User = "User"


}
export enum EnumCredentialCheckerTypes {
    ContactPerson = "ContactPerson",
    Customer = "Customer"


}
export enum EnumDocumentTypes {
    LedgerTypes = "LedgerTypes",
    Delivery = "Delivery",
    Order = "Order",
    PriceProposal = "PriceProposal"


}
export enum EnumPaymentMethod {
    CreditCard = "CreditCard",
    Paypal = "Paypal",
    Bit = "Bit"


}
export enum EnumDeliveryMethods {
    Email = "Email",
    Phone = "Phone",
    WhatsApp = "WhatsApp",
    Portal = "Portal",
    Unknown = "Unknown"


}
export enum EnumDocumentFilteringOption {
    ShowOpen = "ShowOpen",
    ShowAll = "ShowAll",
    Automatic = "Automatic"


}

export enum EnumDocumentDownloadOption {
    PDF = "PDF",
    ZIP = "ZIP"
}


export const Enums = {
    EnumSystemOptionsZ: EnumSystemOptionsZ,
    EnumEntityTypes: EnumEntityTypes,
    EnumInvoicePaymentTypes: EnumInvoicePaymentTypes,
    EnumLoginRequestTypes: EnumLoginRequestTypes,
    EnumCustomerAddressTypes: EnumCustomerAddressTypes,
    EnumPaymentRequestTypes: EnumPaymentRequestTypes,
    EnumPaymentRequestStatuses: EnumPaymentRequestStatuses,
    EnumAutoCreationDocumentTypes: EnumAutoCreationDocumentTypes,
    EnumFileTypes: EnumFileTypes,
    EnumReportTabs: EnumReportTabs,
    EnumUserTypes: EnumUserTypes,
    EnumPaymentRequestSteps: EnumPaymentRequestSteps,
    EnumSystemTypes: EnumSystemTypes,
    EnumCredentialTypes: EnumCredentialTypes,
    EnumCredentialCheckerTypes: EnumCredentialCheckerTypes,
    EnumDocumentTypes: EnumDocumentTypes,
    EnumPaymentMethod: EnumPaymentMethod,
    EnumDeliveryMethods: EnumDeliveryMethods,
    EnumDocumentFilteringOption: EnumDocumentFilteringOption,
    EnumDocumentDownloadOption: EnumDocumentDownloadOption
};



